module.exports = __webpack_public_path__ + "static/penmorebenefits-logo-721b09396b2454ae54a9ebb8b371a61b.png";